"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseQuery_1 = require("./BaseQuery");
var object_1 = require("../utils/object");
var FundManagerQuery = /** @class */ (function (_super) {
    __extends(FundManagerQuery, _super);
    function FundManagerQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FundManagerQuery.prototype.initialize = function (executionOptions) {
        this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
        this.fillKeyFromQuery('extendedKey', 'extendedKeyQuery', executionOptions);
    };
    FundManagerQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, key = _a.key, keyQuery = _a.keyQuery, extendedKey = _a.extendedKey, _b = _a.options, options = _b === void 0 ? {} : _b;
        return __assign({ key: key,
            keyQuery: keyQuery,
            extendedKey: extendedKey }, (options.fundManager || {}));
    };
    FundManagerQuery.prototype.getRawValue = function (executionOptions) {
        var _a = this.options, key = _a.key, extendedKey = _a.extendedKey;
        var fundManager = this.getFundManager(executionOptions);
        if (fundManager) {
            if (key) {
                var biographies = fundManager.biography;
                if (key === 'biography' && biographies) {
                    var culture_1 = executionOptions.culture, fallbackCulture_1 = executionOptions.fallbackCulture;
                    var biographyItem = biographies.find(function (biography) { return biography.culture === culture_1; });
                    if (!biographyItem) {
                        biographyItem = biographies.find(function (biography) { return biography.culture === fallbackCulture_1; });
                    }
                    return (biographyItem && biographyItem.biography);
                }
                if (key === 'extended') {
                    var extended = extendedKey && fundManager.extended && object_1.getValueFromStringNotation(extendedKey, fundManager.extended);
                    return extended && extended.value || extended;
                }
                return fundManager[key];
            }
            return fundManager;
        }
        return;
    };
    return FundManagerQuery;
}(BaseQuery_1.BaseQuery));
exports.FundManagerQuery = FundManagerQuery;
//# sourceMappingURL=FundManagerQuery.js.map